module.exports.questions = {
    Standard: [
        {
            id: 708,
            options:
                "A poor widow, because she was thirsty;Rebecca, because the Lord gave this as a sign;Jethro, because he was attacked",
            answer: "Reuel's daughters, as they were driven away from the well",
            difficulty: "hard",
            type: "old",
            question: "Who did Moses help at Midian's well and why?",
            description:
                "„Now the priest of Midian had seven daughters, and they came and drew water and filled the troughs to water their father's flock. The shepherds came and drove them away, but Moses stood up and saved them, and watered their flock.” (Exodus 2,16-17)"
        },
        {
            id: 551,
            options:
                "To ask her about David's hidden intentions;To defeat his enemies with the help of evil spirits;He wanted to trap the medium for her forbidden acts",
            answer: "God didn't answer him concerning the war against the Philistines",
            difficulty: "hard",
            type: "old",
            question: "Why did Saul visit the medium?",
            description:
                '„When Saul saw the army of the Philistines, he was afraid, and his heart trembled greatly. And when Saul inquired of the LORD, the LORD did not answer him, either by dreams, or by Urim, or by prophets. Then Saul said to his servants, "Seek out for me a woman who is a medium, that I may go to her and inquire of her." And his servants said to him, "Behold, there is a medium at En-dor."” (1Samuel 28,5-7)'
        },
        {
            id: 77,
            options: "Locusts;Pestilence;Death of every firstborn",
            answer: "Darkness",
            difficulty: "hard",
            type: "old",
            question: "Which was the 9th plague to strike Egypt?",
            description:
                '„Then the LORD said to Moses, "Stretch out your hand toward heaven, that there may be darkness over the land of Egypt, a darkness to be felt." So Moses stretched out his hand toward heaven, and there was pitch darkness in all the land of Egypt three days.” (Exodus 10,21-22)a„Then the LORD said to Moses, "Stretch out your hand toward heaven, that there may be darkness over the land of Egypt, a darkness to be felt." So Moses stretched out his hand toward heaven, and there was pitch darkness in all the land of Egypt three days.” (Exodus 10,21-22)'
        },
        {
            id: 660,
            options: "He killed his brother;He married his father's servant;He sacrificed his son to God",
            answer: "He spilled his semen on the ground, to avoid providing Tamar with offspring",
            difficulty: "hard",
            type: "old",
            question: "For what reason did the Lord kill Onan?",
            description:
                "„But Onan knew that the offspring would not be his. So whenever he went in to his brother's wife he would waste the semen on the ground, so as not to give offspring to his brother. And what he did was wicked in the sight of the LORD, and he put him to death also.” (Genesis 38,9-10)"
        },
        {
            id: 108,
            options:
                "He acted mercifully to others, as did the king to him;The king forgave him and didn't change his mind;He believed in the king's grace and his sins were forgiven",
            answer: "He wasn't merciful to others and the king changed his mind",
            difficulty: "easy",
            type: "new",
            question: "What happened to the slave after a king cancelled his debts? (Matthew 18)",
            description:
                "„Then his master summoned him and said to him, 'You wicked servant! I forgave you all that debt because you pleaded with me. And should not you have had mercy on your fellow servant, as I had mercy on you?' And in anger his master delivered him to the jailers, until he should pay all his debt.” (Matthew 18,32-34)"
        },
        {
            id: 1,
            options: "Elijah;Elisha;Hoshea",
            answer: "Jonah",
            difficulty: "easy",
            type: "old",
            question: "Who spent 3 days within the belly of a huge fish?",
            description: "„Then Jonah prayed to the LORD his God from the belly of the fish…” (Jonah 2,1)"
        },
        {
            id: 2,
            options: "Peter;Andrew;Thomas",
            answer: "Luke",
            difficulty: "easy",
            type: "new",
            question: "Who was not part of the 12 disciples?",
            description:
                "„Simon, whom he named Peter, and Andrew his brother, and James and John, and Philip, and Bartholomew, and Matthew, and Thomas, and James the son of Alphaeus, and Simon who was called the Zealot, and Judas the son of James, and Judas Iscariot, who became a traitor.” (Luke 6,14-16)"
        },
        {
            id: 3,
            options: "Jacob;Ishmael;Joseph",
            answer: "Abraham",
            difficulty: "easy",
            type: "old",
            question: "Who was the father of Isaac?",
            description:
                "„Abraham called the name of his son who was born to him, whom Sarah bore him, Isaac.” (Genesis 21,3)"
        },
        {
            id: 4,
            options: "120 years old;145 years old;190 years old",
            answer: "175 years old",
            difficulty: "hard",
            type: "old",
            question: "How old was Abraham when he died?",
            description: "„These are the days of the years of Abraham's life, 175 years.” (Genesis 25,7)"
        },
        {
            id: 5,
            options: "235 years old;677 years old;930 years old",
            answer: "969 years old",
            difficulty: "hard",
            type: "old",
            question: "How long did the oldest person live?",
            description: "„Thus all the days of Methuselah were 969 years, and he died.” (Genesis 5,27)"
        },
        {
            id: 6,
            options: "5 commandments;8 commandments;12 commandments",
            answer: "10 commandments",
            difficulty: "easy",
            type: "old",
            question: "How many commandments did Moses receive on tablets of stone?",
            description:
                "„So he was there with the LORD forty days and forty nights. He neither ate bread nor drank water. And he wrote on the tablets the words of the covenant, the Ten Commandments.” (Exodus 34,28)"
        },
        {
            id: 7,
            options: "Committed suicide;In the battle;Accident",
            answer: "Old age",
            difficulty: "hard",
            type: "old",
            question: "How did David die?",
            description:
                "„Then he died at a good age, full of days, riches, and honor. And Solomon his son reigned in his place.” (1Chronicles 29,28)"
        },
        {
            id: 8,
            options: "David;Levi;Samuel",
            answer: "Jonathan",
            difficulty: "hard",
            type: "old",
            question: "Who was the son of King Saul?",
            description:
                "„And Saul and Jonathan his son and the people who were present with them stayed in Geba of Benjamin, but the Philistines encamped in Michmash.” (1Samuel 13,16)"
        },
        {
            id: 9,
            options: "Absalom;Gideon;Solomon",
            answer: "Samson",
            difficulty: "easy",
            type: "old",
            question: "Who lost his supernatural strength when his hair was cut off?",
            description:
                "„And he told her all his heart, and said to her, \"A razor has never come upon my head, for I have been a Nazirite to God from my mother's womb. If my head is shaved, then my strength will leave me, and I shall become weak and be like any other man.” (Judges 16,17)"
        },
        {
            id: 10,
            options: "Noah;Elisha;Moses",
            answer: "Elijah",
            difficulty: "hard",
            type: "old",
            question: "To whom did the ravens bring food?",
            description:
                "„And the ravens brought him bread and meat in the morning, and bread and meat in the evening, and he drank from the brook.” (1Kings 17,6)"
        },
        {
            id: 11,
            options: "Jonathan;Saul;Samson",
            answer: "David",
            difficulty: "easy",
            type: "old",
            question: "Who defeated Goliath?",
            description:
                "„Then David ran and stood over the Philistine and took his sword and drew it out of its sheath and killed him and cut off his head with it. When the Philistines saw that their champion was dead, they fled.” (1Samuel 17,51)"
        },
        {
            id: 12,
            options: "Bathsheba;Sarah;Rebekah",
            answer: "Ruth",
            difficulty: "hard",
            type: "old",
            question: "Who did Boaz marry?",
            description:
                "„So Boaz took Ruth, and she became his wife. And he went in to her, and the LORD gave her conception, and she bore a son.” (Ruth 4,13)"
        },
        {
            id: 13,
            options: "Moses;Aaron;Elisha",
            answer: "Elijah",
            difficulty: "hard",
            type: "old",
            question: "Whose cloak was used to part a river?",
            description:
                '„Then he took the cloak of Elijah that had fallen from him and struck the water, saying, "Where is the LORD, the God of Elijah?" And when he had struck the water, the water was parted to the one side and to the other, and Elisha went over.” (2Kings 2,14)'
        },
        {
            id: 14,
            options: "David;Abimelech;Abraham",
            answer: "Solomon",
            difficulty: "hard",
            type: "old",
            question: "Who had seven hundred wives and three hundred concubines?",
            description:
                "„He had 700 wives, princesses, and 300 concubines. And his wives turned away his heart.” (1Kings 11,3)"
        },
        {
            id: 15,
            options: "Daughter of Herod;Sisera's nurse;Abimelech's wife",
            answer: "Widow of one of the prophets",
            difficulty: "hard",
            type: "old",
            question: "Whose small jar of oil filled all the jars she could gather?",
            description:
                '„When the vessels were full, she said to her son, "Bring me another vessel." And he said to her, "There is not another." Then the oil stopped flowing.” (2Kings 4,6)'
        },
        {
            id: 16,
            options: "Aaron;Abraham;Lot",
            answer: "Jethro",
            difficulty: "hard",
            type: "old",
            question: "Who was Moses' father-in-law?",
            description:
                "„Now Moses was keeping the flock of his father-in-law, Jethro, the priest of Midian, and he led his flock to the west side of the wilderness and came to Horeb, the mountain of God.” (Exodus 3,1)"
        },
        {
            id: 17,
            options: "Adam;Abel;Lamech",
            answer: "Cain",
            difficulty: "easy",
            type: "old",
            question: "Who was the first murderer?",
            description:
                "„Cain spoke to Abel his brother. And when they were in the field, Cain rose up against his brother Abel and killed him.” (Genesis 4,8)"
        },
        {
            id: 18,
            options: "Solomon;Ahaz;David",
            answer: "Jesus",
            difficulty: "easy",
            type: "new",
            question: "Who was the young boy who amazed others with his understanding and answers?",
            description: "„And all who heard him were amazed at his understanding and his answers.” (Luke 2,47)"
        },
        {
            id: 19,
            options: "Paul;Matthew;Peter",
            answer: "Zacchaeus",
            difficulty: "easy",
            type: "new",
            question: "Who was so short that he climbed up a tree to see Jesus?",
            description:
                "„And he was seeking to see who Jesus was, but on account of the crowd he could not, because he was small of stature. So he ran on ahead and climbed up into a sycamore tree to see him, for he was about to pass that way.” (Luke 19,3-4)"
        },
        {
            id: 20,
            options: "Eli;Saul;Abraham",
            answer: "David",
            difficulty: "hard",
            type: "old",
            question: "Who was despised by his wife for dancing before the Lord?",
            description:
                "„And as the ark of the covenant of the LORD came to the city of David, Michal the daughter of Saul looked out of the window and saw King David dancing and rejoicing, and she despised him in her heart.” (1Chronicles 15,29)"
        },
        {
            id: 21,
            options: "Habakkuk;Micaiah;Zechariah",
            answer: "Hosea",
            difficulty: "hard",
            type: "old",
            question: "Who did the Lord command to marry a prostitute?",
            description:
                '„When the LORD first spoke through Hosea, the LORD said to Hosea, "Go, take to yourself a wife of whoredom and have children of whoredom, for the land commits great whoredom by forsaking the LORD."” (Hosea 1,2)'
        },
        {
            id: 22,
            options: "Mary and Joanna;Mary and Elizabeth;Mary and Magdalene",
            answer: "Mary and Martha",
            difficulty: "easy",
            type: "new",
            question: "Who were Lazarus' siblings?",
            description:
                "„Now a certain man was ill, Lazarus of Bethany, the village of Mary and her sister Martha.” (John 11,1)"
        },
        {
            id: 23,
            options: "Jerusalem;Bethany;Nazareth",
            answer: "Jericho",
            difficulty: "hard",
            type: "new",
            question: "Where did Jesus cure the blind Bartimaeus?",
            description:
                "„And they came to Jericho. And as he was leaving Jericho with his disciples and a great crowd, Bartimaeus, a blind beggar, the son of Timaeus, was sitting by the roadside.” (Mark 10,46)"
        },
        {
            id: 24,
            options: "Bartimaeus;Eli;David",
            answer: "Samson",
            difficulty: "hard",
            type: "old",
            question: "Who was blind but still killed many with his death?",
            description:
                '„And Samson said, "Let me die with the Philistines." Then he bowed with all his strength, and the house fell upon the lords and upon all the people who were in it. So the dead whom he killed at his death were more than those whom he had killed during his life.” (Judges 16,30)'
        },
        {
            id: 25,
            options: "Lion;Horse;Sheep",
            answer: "Donkey",
            difficulty: "hard",
            type: "old",
            question: "What kind of animal questioned its owner for being beaten?",
            description:
                '„Then the LORD opened the mouth of the donkey, and she said to Balaam, "What have I done to you, that you have struck me these three times?"” (Numbers 22,28)'
        },
        {
            id: 26,
            options: "Jerusalem;Nazareth;Jericho",
            answer: "Bethlehem",
            difficulty: "easy",
            type: "new",
            question: "Where was Jesus born?",
            description:
                "„Now after Jesus was born in Bethlehem of Judea in the days of Herod the king, behold, wise men from the east came to Jerusalem...” (Matthew 2,1)"
        },
        {
            id: 27,
            options: "Isaac;Abraham;Joseph",
            answer: "Jacob",
            difficulty: "hard",
            type: "old",
            question: "Who served 14 years for two women?",
            description:
                "„These twenty years I have been in your house. I served you fourteen years for your two daughters, and six years for your flock, and you have changed my wages ten times.” (Genesis 31,36-41)"
        },
        {
            id: 28,
            options: "Moses;Abraham;Gideon",
            answer: "Joshua",
            difficulty: "hard",
            type: "old",
            question: "Whose words made the sun stand still?",
            description:
                '„At that time Joshua spoke to the LORD in the day when the LORD gave the Amorites over to the sons of Israel, and he said in the sight of Israel, "Sun, stand still at Gibeon, and moon, in the Valley of Aijalon."” (Joshua 10,12)'
        },
        {
            id: 29,
            options: "Shadrach;Solomon;Simeon",
            answer: "Samson",
            difficulty: "hard",
            type: "old",
            question: "Who used foxes to set fire to grain and olive orchards?",
            description:
                "„So Samson went and caught 300 foxes and took torches. And he turned them tail to tail and put a torch between each pair of tails. And when he had set fire to the torches, he let the foxes go into the standing grain of the Philistines and set fire to the stacked grain and the standing grain, as well as the olive orchards.” (Judges 15,4-5)"
        },
        {
            id: 30,
            options: "2 thousand;18 thousand;35 thousand",
            answer: "185 thousand",
            difficulty: "hard",
            type: "old",
            question: "How many Assyrians were struck down by an angel in one day?",
            description:
                "„And that night the angel of the LORD went out and struck down 185,000 in the camp of the Assyrians. And when people arose early in the morning, behold, these were all dead bodies.” (2Kings 19,35)"
        },
        {
            id: 31,
            options: "David;Saul;Jonathan",
            answer: "Solomon",
            difficulty: "hard",
            type: "old",
            question: "Who wrote most of the book of Proverbs?",
            description: "„The proverbs of Solomon, son of David, king of Israel:” (Proverbs 1,1)"
        },
        {
            id: 32,
            options: "In a pillar of fire;In a pillar of cloud;By an angel",
            answer: "In a whirlwind",
            difficulty: "hard",
            type: "old",
            question: "How did Elijah ascend into Heaven?",
            description:
                "„And as they still went on and talked, behold, chariots of fire and horses of fire separated the two of them. And Elijah went up by a whirlwind into heaven.” (2Kings 2,11)"
        },
        {
            id: 33,
            options: "A horseshoe;A wooden box;A sword",
            answer: "An axhead",
            difficulty: "hard",
            type: "old",
            question: "What did Elisha bring up to the water's surface?",
            description:
                '„But as one was felling a log, his axe head fell into the water, and he cried out, "Alas, my master! It was borrowed." Then the man of God said, "Where did it fall?" When he showed him the place, he cut off a stick and threw it in there and made the iron float. And he said, "Take it up." So he reached out his hand and took it.” (2Kings 6,5-7)'
        },
        {
            id: 34,
            options: "End of the world;Angels;Easter",
            answer: "Covenant",
            difficulty: "easy",
            type: "old",
            question: "What does a rainbow symbolise in the Bible?",
            description:
                "„I have set my bow in the cloud, and it shall be a sign of the covenant between me and the earth.” (Genesis 9,13)"
        },
        {
            id: 35,
            options: "In an earthquake;In fire;In a strong wind",
            answer: "In a low whisper",
            difficulty: "hard",
            type: "old",
            question: "How did the Lord appear to Elijah?",
            description:
                "„And after the earthquake a fire, but the LORD was not in the fire. And after the fire the sound of a low whisper.” (1Kings 19,12)"
        },
        {
            id: 36,
            options: "Adam;Lamech;Noah",
            answer: "Methuselah",
            difficulty: "hard",
            type: "old",
            question: "Who was the oldest man ever to live?",
            description: "„Thus all the days of Methuselah were 969 years, and he died.” (Genesis 5,27)"
        },
        {
            id: 37,
            options: "Sword;Bow;Chariot",
            answer: "Sling",
            difficulty: "easy",
            type: "old",
            question: "With what weapon was Goliath defeated?",
            description:
                "„So David prevailed over the Philistine with a sling and with a stone, and struck the Philistine and killed him. There was no sword in the hand of David.” (1Samuel 17,50)"
        },
        {
            id: 38,
            options: "Apple;Pear;Figs",
            answer: "Not known...",
            difficulty: "easy",
            type: "old",
            question: "Which kind of fruit was forbidden in the garden of Eden?",
            description: "The Bible does not mention about what fruit was the forbidden one."
        },
        {
            id: 39,
            options: "Elijah;Paul;Elisha",
            answer: "Moses",
            difficulty: "hard",
            type: "old",
            question: "Who grabbed a snake by its tail?",
            description:
                '„But the LORD said to Moses, "Put out your hand and catch it by the tail"--so he put out his hand and caught it, and it became a staff in his hand--” (Exodus 4,4)'
        },
        {
            id: 40,
            options: "Joseph;Luke;Stephen",
            answer: "Matthias",
            difficulty: "easy",
            type: "new",
            question: "Who was numbered along with the 11 apostles?",
            description:
                "„And they cast lots for them, and the lot fell on Matthias, and he was numbered with the eleven apostles.” (Acts 1,26)"
        },
        {
            id: 41,
            options: "Barley;Lentils;A dog",
            answer: "Wheat",
            difficulty: "hard",
            type: "old",
            question: "What did Gideon “beat out” in the winepress?",
            description:
                "„Now the angel of the LORD came and sat under the terebinth at Ophrah, which belonged to Joash the Abiezrite, while his son Gideon was beating out wheat in the winepress to hide it from the Midianites.” (Judges 6,11)"
        },
        {
            id: 42,
            options: "Lazarus;Elisha;Hazael",
            answer: "Gehazi",
            difficulty: "hard",
            type: "old",
            question: "Who was punished with leprosy because he accepted gifts?",
            description:
                '„Therefore the leprosy of Naaman shall cling to you and to your descendants forever." So he went out from his presence a leper, like snow.” (2Kings 5,27)'
        },
        {
            id: 43,
            options: "Samuel;David;Deborah",
            answer: "Gideon",
            difficulty: "hard",
            type: "old",
            question: "Who was the leader of 300 men who defeated the Midian army?",
            description:
                '„And the LORD said to Gideon, "With the 300 men who lapped I will save you and give the Midianites into your hand, and let all the others go every man to his home."” (Judges 7,7)'
        },
        {
            id: 44,
            options: "Demas;Timothy;Philemon",
            answer: "Eutychus",
            difficulty: "hard",
            type: "new",
            question: "Who fell out of a window while Paul was preaching?",
            description:
                "„And a young man named Eutychus, sitting at the window, sank into a deep sleep as Paul talked still longer. And being overcome by sleep, he fell down from the third story and was taken up dead.” (Acts 20,9)"
        },
        {
            id: 45,
            options: "Samaria;Jerusalem;Shechem",
            answer: "Jericho",
            difficulty: "easy",
            type: "old",
            question: "Which city's walls collapsed on the 7th day?",
            description:
                "„On the seventh day you shall march around the city seven times, and the priests shall blow the trumpets. And when they make a long blast with the ram's horn, when you hear the sound of the trumpet, then all the people shall shout with a great shout, and the wall of the city will fall down flat, and the people shall go up, everyone straight before him.\"” (Joshua 6,4-5)"
        },
        {
            id: 46,
            options: "Isaiah;Jeremiah;Jonah",
            answer: "Elisha",
            difficulty: "hard",
            type: "old",
            question: "Who was Elijah's disciple?",
            description:
                "„And he returned from following him and took the yoke of oxen and sacrificed them and boiled their flesh with the yokes of the oxen and gave it to the people, and they ate. Then he arose and went after Elijah and assisted him.” (1Kings 19,21)"
        },
        {
            id: 47,
            options: "Absalom;Ahithophel;Abishai",
            answer: "Shimei",
            difficulty: "hard",
            type: "old",
            question: "Who threw stones and cursed King David?",
            description:
                "„When King David came to Bahurim, there came out a man of the family of the house of Saul, whose name was Shimei, the son of Gera, and as he came he cursed continually. And he threw stones at David and at all the servants of King David, and all the people and all the mighty men were on his right hand and on his left.” (2Samuel 16,5-6)"
        },
        {
            id: 48,
            options: "Saul;Shimei;Balak",
            answer: "Balaam",
            difficulty: "hard",
            type: "old",
            question: "Who was asked to curse Israel, but he could only bless them?",
            description:
                "„And Balak's anger was kindled against Balaam, and he struck his hands together. And Balak said to Balaam, \"I called you to curse my enemies, and behold, you have blessed them these three times.” (Numbers 24,10)"
        },
        {
            id: 49,
            options: "David;Saul;Ahaz",
            answer: "Nebuchadnezzar",
            difficulty: "hard",
            type: "old",
            question: "From whom did God take away their reasoning but later received it back again?",
            description:
                "„At the same time my reason returned to me, and for the glory of my kingdom, my majesty and splendor returned to me. My counselors and my lords sought me, and I was established in my kingdom, and still more greatness was added to me. Now I, Nebuchadnezzar, praise and extol and honor the King of heaven, for all his works are right and his ways are just; and those who walk in pride he is able to humble.” (Daniel 4,36-37)"
        },
        {
            id: 50,
            options: "Nebuchadnezzar;Jacob;Peter",
            answer: "David",
            difficulty: "hard",
            type: "old",
            question: "Who was so afraid that he drew marks on the doors and let spittle run down his beard?",
            description:
                "„And David took these words to heart and was much afraid of Achish the king of Gath. So he changed his behavior before them and pretended to be insane in their hands and made marks on the doors of the gate and let his spittle run down his beard.” (1Samuel 21,12-13)"
        },
        {
            id: 51,
            options: "Jordan;Euphrates;Both of them",
            answer: "Neither of them",
            difficulty: "hard",
            type: "new",
            question: "In which river did Jesus baptize?",
            description: "„(although Jesus himself did not baptize, but only his disciples)” (John 4,2)"
        },
        {
            id: 52,
            options: "Ahaz;Saul;Ahab",
            answer: "Jezebel",
            difficulty: "hard",
            type: "old",
            question: "Who was eaten by dogs?",
            description:
                "„When they came back and told him, he said, \"This is the word of the LORD, which he spoke by his servant Elijah the Tishbite, 'In the territory of Jezreel the dogs shall eat the flesh of Jezebel,” (2Kings 9,36)"
        },
        {
            id: 53,
            options: "Mark;Luke;Rich young man",
            answer: "Matthew (Levi)",
            difficulty: "easy",
            type: "new",
            question: "Who left everything behind and followed Jesus when he was called?",
            description:
                '„After this he went out and saw a tax collector named Levi, sitting at the tax booth. And he said to him, "Follow me." And leaving everything, he rose and followed him.” (Luke 5,27-28)'
        },
        {
            id: 54,
            options: "Saul;Jehu;Shimei",
            answer: "Jephthah",
            difficulty: "hard",
            type: "old",
            question: "Who sacrificed his own daughter because of his vow to God?",
            description:
                "„And at the end of two months, she returned to her father, who did with her according to his vow that he had made. She had never known a man, and it became a custom in Israel that the daughters of Israel went year by year to lament the daughter of Jephthah the Gileadite four days in the year.” (Judges 11,39-40)"
        },
        {
            id: 55,
            options: "Saul;Solomon;Shimei",
            answer: "Samson",
            difficulty: "hard",
            type: "old",
            question: "Who told his wife the source of his great strength?",
            description:
                '„And he told her all his heart, and said to her, "A razor has never come upon my head, for I have been a Nazirite to God from my mother\'s womb. If my head is shaved, then my strength will leave me, and I shall become weak and be like any other man."” (Judges 16,17)'
        },
        {
            id: 56,
            options: "King of Shinar;King of Sodom;King of Ellasar",
            answer: "King of Salem",
            difficulty: "hard",
            type: "old",
            question: "Which king brought wine and bread to Abraham?",
            description:
                "„And Melchizedek king of Salem brought out bread and wine. (He was priest of God Most High.)” (Genesis 14,18)"
        },
        {
            id: 57,
            options: "Philemon;Tychicus;Silas",
            answer: "Timothy",
            difficulty: "hard",
            type: "new",
            question: "Who was advised to drink wine for his frequent stomach ailments?",
            description:
                "„(No longer drink only water, but use a little wine for the sake of your stomach and your frequent ailments.)” (1Timothy 5,23)"
        },
        {
            id: 58,
            options: "Elijah;Aaron;David",
            answer: "Elisha",
            difficulty: "hard",
            type: "old",
            question: "Who was jeered at by children because of his bald head?",
            description:
                '„He went up from there to Bethel, and while he was going up on the way, some small boys came out of the city and jeered at him, saying, "Go up, you baldhead! Go up, you baldhead!"” (2Kings 2,23)'
        },
        {
            id: 59,
            options: "Lion;Horse;Snake",
            answer: "Ostrich",
            difficulty: "hard",
            type: "old",
            question: "Which animal treats its young cruelly?",
            description:
                "„She deals cruelly with her young, as if they were not hers; though her labor be in vain, yet she has no fear, because God has made her forget wisdom and given her no share in understanding.” (Job 39,16-17)"
        },
        {
            id: 60,
            options: "Daniel;David;Solomon",
            answer: "Job",
            difficulty: "hard",
            type: "old",
            question: "Who lost everything, but after a trial God blessed his latter days?",
            description:
                "„And the LORD blessed the latter days of Job more than his beginning. And he had 14,000 sheep, 6,000 camels, 1,000 yoke of oxen, and 1,000 female donkeys. He had also seven sons and three daughters.” (Job 42,12-13)"
        },
        {
            id: 61,
            options: "A lion;A man;A piano fell on him",
            answer: "A woman",
            difficulty: "hard",
            type: "old",
            question: "Who or what killed Sisera while he was sleeping?",
            description:
                "„But Jael the wife of Heber took a tent peg, and took a hammer in her hand. Then she went softly to him and drove the peg into his temple until it went down into the ground while he was lying fast asleep from weariness. So he died.” (Judges 4,21)"
        },
        {
            id: 62,
            options: "Wood;Iron;Gold",
            answer: "Bronze",
            difficulty: "hard",
            type: "old",
            question: "What did Moses make the serpent out of?",
            description:
                '„And the LORD said to Moses, "Make a fiery serpent and set it on a pole, and everyone who is bitten, when he sees it, shall live." So Moses made a bronze serpent and set it on a pole. And if a serpent bit anyone, he would look at the bronze serpent and live.” (Numbers 21,8-9)'
        },
        {
            id: 63,
            options: "Golden calves;Stone tablets;Tent of meeting",
            answer: "Bronze serpent",
            difficulty: "hard",
            type: "old",
            question: "What did God command to be made but became an idol?",
            description:
                "„He removed the high places and broke the pillars and cut down the Asherah. And he broke in pieces the bronze serpent that Moses had made, for until those days the people of Israel had made offerings to it (it was called Nehushtan).” (2Kings 18,4)"
        },
        {
            id: 64,
            options: "20 shekels of silver;A young goat;A jar of oil ",
            answer: "Bread and lentil stew",
            difficulty: "easy",
            type: "old",
            question: "What did Jacob give in exchange for Esau's birthright which Esau came to despise?",
            description:
                '„Jacob said, "Swear to me now." So he swore to him and sold his birthright to Jacob. Then Jacob gave Esau bread and lentil stew, and he ate and drank and rose and went his way. Thus Esau despised his birthright.” (Genesis 25,33-34)'
        },
        {
            id: 65,
            options: "Isaiah;Job;Elijah",
            answer: "David",
            difficulty: "easy",
            type: "old",
            question: "About whom did God say, “a man after my heart, who will do all my will”?",
            description:
                "„And when he had removed him, he raised up David to be their king, of whom he testified and said, 'I have found in David the son of Jesse a man after my heart, who will do all my will.'” (Acts 13,22)"
        },
        {
            id: 66,
            options: "David;Peter;Philip",
            answer: "Paul",
            difficulty: "easy",
            type: "new",
            question: "Who had a thorn in his flesh?",
            description:
                "„So to keep me from becoming conceited because of the surpassing greatness of the revelations, a thorn was given me in the flesh, a messenger of Satan to harass me, to keep me from becoming conceited.” (2Corinthians 12,7)"
        },
        {
            id: 67,
            options: "Daniel;Elijah;Isaiah",
            answer: "Ezekiel",
            difficulty: "hard",
            type: "old",
            question: "Who prophesied to a valley of dry bones and they came back to life?",
            description:
                "„So I prophesied as I was commanded. And as I prophesied, there was a sound, and behold, a rattling, and the bones came together, bone to its bone. And I looked, and behold, there were sinews on them, and flesh had come upon them, and skin had covered them. But there was no breath in them.” (Ezekiel 37,7-8)"
        },
        {
            id: 68,
            options: "5 years;10 years;20 years",
            answer: "15 years",
            difficulty: "hard",
            type: "old",
            question: "By how many years did God extend Hezekiah's life?",
            description:
                "„Go and say to Hezekiah, Thus says the LORD, the God of David your father: I have heard your prayer; I have seen your tears. Behold, I will add fifteen years to your life.” (Isaiah 38,5)"
        },
        {
            id: 69,
            options: "Pilate;Judas;Ananias",
            answer: "Herod",
            difficulty: "hard",
            type: "new",
            question: "Who was eaten by worms because he did not give God the glory?",
            description:
                '„On an appointed day Herod put on his royal robes, took his seat upon the throne, and delivered an oration to them. And the people were shouting, "The voice of a god, and not of a man!" Immediately an angel of the Lord struck him down, because he did not give God the glory, and he was eaten by worms and breathed his last.” (Acts 12,21-23)'
        },
        {
            id: 70,
            options: "Peppers;Mint;Cinnamon",
            answer: "Salt",
            difficulty: "easy",
            type: "new",
            question: "To what did Jesus compare his disciples?",
            description:
                "„You are the salt of the earth, but if salt has lost its taste, how shall its saltiness be restored? It is no longer good for anything except to be thrown out and trampled under people's feet.” (Matthew 5,13)"
        },
        {
            id: 71,
            options: "A woman;A scroll;Oil",
            answer: "All kinds of animals",
            difficulty: "easy",
            type: "new",
            question: "What did Peter see inside the great sheet that descended from heaven during his vision?",
            description:
                "„And he became hungry and wanted something to eat, but while they were preparing it, he fell into a trance and saw the heavens opened and something like a great sheet descending, being let down by its four corners upon the earth. In it were all kinds of animals and reptiles and birds of the air.” (Acts 10,10-12)"
        },
        {
            id: 72,
            options: "David;Solomon;Samuel",
            answer: "Saul",
            difficulty: "easy",
            type: "old",
            question: "Who was Israel's first king?",
            description:
                '„Then Samuel said to the people, "Come, let us go to Gilgal and there renew the kingdom." So all the people went to Gilgal, and there they made Saul king before the LORD in Gilgal. There they sacrificed peace offerings before the LORD, and there Saul and all the men of Israel rejoiced greatly.” (1Samuel 11,14-15)'
        },
        {
            id: 73,
            options: "John;James;Andrew",
            answer: "Peter",
            difficulty: "easy",
            type: "new",
            question: "Who argued with Jesus about washing his feet?",
            description:
                '„Peter said to him, "You shall never wash my feet." Jesus answered him, "If I do not wash you, you have no share with me." Simon Peter said to him, "Lord, not my feet only but also my hands and my head!"” (John 13,8-9)'
        },
        {
            id: 74,
            options: "John;Paul;James",
            answer: "Peter",
            difficulty: "hard",
            type: "new",
            question: "Whose shadow healed the sick/ill?",
            description:
                "„so that they even carried out the sick into the streets and laid them on cots and mats, that as Peter came by at least his shadow might fall on some of them. The people also gathered from the towns around Jerusalem, bringing the sick and those afflicted with unclean spirits, and they were all healed.” (Acts 5,15-16)"
        },
        {
            id: 75,
            options: "3 months;1 year;9 years and 6 months",
            answer: "40 years",
            difficulty: "hard",
            type: "old",
            question: "For how long did Israel eat manna?",
            description:
                "„The people of Israel ate the manna forty years, till they came to a habitable land. They ate the manna till they came to the border of the land of Canaan.” (Exodus 16,35)"
        },
        {
            id: 76,
            options: "Elisha;Lamech;Adam",
            answer: "Enoch",
            difficulty: "hard",
            type: "old",
            question: "Who “walked with God, and he was not”?",
            description: "„Enoch walked with God, and he was not, for God took him.” (Genesis 5,24)"
        },
        {
            id: 78,
            options: "Tax collector;Tanner;Fisherman",
            answer: "Tentmaker",
            difficulty: "hard",
            type: "new",
            question: "What was Paul's occupation?",
            description:
                "„After this Paul left Athens and went to Corinth. And he found a Jew named Aquila, a native of Pontus, recently come from Italy with his wife Priscilla, because Claudius had commanded all the Jews to leave Rome. And he went to see them, and because he was of the same trade he stayed with them and worked, for they were tentmakers by trade.” (Acts 18,1-3)"
        },
        {
            id: 79,
            options: "The ones who hurry;The ones who think positively;The ones who get baptized ",
            answer: "The ones who abide within Him",
            difficulty: "easy",
            type: "new",
            question: "According to Jesus, who “bears much fruit”?",
            description:
                "„I am the vine; you are the branches. Whoever abides in me and I in him, he it is that bears much fruit, for apart from me you can do nothing.” (John 15,5)"
        },
        {
            id: 80,
            options: "4th day;5th day;7th day",
            answer: "6th day",
            difficulty: "hard",
            type: "old",
            question: "On which day did God create man?",
            description:
                "„So God created man in his own image, in the image of God he created him; male and female he created them... And God saw everything that he had made, and behold, it was very good. And there was evening and there was morning, the sixth day.” (Genesis 1,27-31)"
        },
        {
            id: 81,
            options: "Those given permission by an elder;Those who pay their tithe;Those who speak in tongues",
            answer: "Those who examine themselves",
            difficulty: "hard",
            type: "new",
            question: "Who are allowed to partake in the Lord's supper?",
            description:
                "„Let a person examine himself, then, and so eat of the bread and drink of the cup.” (1Corinthians 11,28)"
        },
        {
            id: 82,
            options: "Caleb;Joshua",
            answer: "Moses",
            difficulty: "hard",
            type: "old",
            question: "Who did the Lord not allow to enter the promised land?",
            description:
                "„Please let me go over and see the good land beyond the Jordan, that good hill country and Lebanon.” But the LORD was angry with me because of you and would not listen to me. And the LORD said to me, 'Enough from you; do not speak to me of this matter again.” (Deuteronomy 3,25-26)"
        },
        {
            id: 83,
            options: "6;10;12",
            answer: "8",
            difficulty: "easy",
            type: "new",
            question: "How many people went into Noah's ark?",
            description:
                "„because they formerly did not obey, when God's patience waited in the days of Noah, while the ark was being prepared, in which a few, that is, eight persons, were brought safely through water.” (1Peter 3,20)"
        },
        {
            id: 84,
            options: "Pharmacist;Perfumer;Nurse",
            answer: "Seller of purple cloth",
            difficulty: "hard",
            type: "new",
            question: "What was Lydia's occupation?",
            description:
                "„One who heard us was a woman named Lydia, from the city of Thyatira, a seller of purple goods, who was a worshiper of God. The Lord opened her heart to pay attention to what was said by Paul.” (Acts 16,14)"
        },
        {
            id: 85,
            options: "Paul;John;James",
            answer: "Luke",
            difficulty: "hard",
            type: "new",
            question: "Who wrote the book of Acts?",
            description: "Luke wrote his gospel to Theophilus: (Luke 1,3) After this, the Acts too: (Acts 1,1)."
        },
        {
            id: 86,
            options: "80 years;135 years;138 years",
            answer: "120 years",
            difficulty: "hard",
            type: "old",
            question: "How long did Moses live for?",
            description:
                "„Moses was 120 years old when he died. His eye was undimmed, and his vigor unabated.” (Deuteronomy 34,7)"
        },
        {
            id: 87,
            options: "He cried;He laughed;He danced",
            answer: "He slept",
            difficulty: "hard",
            type: "old",
            question: "What was Abraham doing when the Lord made a covenant with him?",
            description:
                '„As the sun was going down, a deep sleep fell on Abram. And behold, dreadful and great darkness fell upon him... On that day the LORD made a covenant with Abram, saying, "To your offspring I give this land, from the river of Egypt to the great river, the river Euphrates,” (Genesis 15,12-18)'
        },
        {
            id: 88,
            options: "Barnabas;Peter;John",
            answer: "Paul",
            difficulty: "hard",
            type: "new",
            question: "Who escaped Damascus by being let down in a basket through an opening in the wall?",
            description:
                "„At Damascus, the governor under King Aretas was guarding the city of Damascus in order to seize me, but I was let down in a basket through a window in the wall and escaped his hands.” (2Corinthians 11,32-33)"
        },
        {
            id: 89,
            options: "David;Samuel;Elijah",
            answer: "Solomon",
            difficulty: "hard",
            type: "old",
            question: "Who built the temple?",
            description:
                "„The house that King Solomon built for the LORD was sixty cubits long, twenty cubits wide, and thirty cubits high.” (1Kings 6,2)"
        },
        {
            id: 90,
            options: "2;3;4",
            answer: "5",
            difficulty: "hard",
            type: "old",
            question: "How many stones did David collect for his battle against Goliath?",
            description:
                "„Then he took his staff in his hand and chose five smooth stones from the brook and put them in his shepherd's pouch. His sling was in his hand, and he approached the Philistine.” (1Samuel 17,40)"
        },
        {
            id: 91,
            options: "Chenaanah;Jehu;David",
            answer: "Rehoboam",
            difficulty: "hard",
            type: "old",
            question: "Who was king after Solomon?",
            description:
                "„And the time that Solomon reigned in Jerusalem over all Israel was forty years. And Solomon slept with his fathers and was buried in the city of David his father. And Rehoboam his son reigned in his place.” (1Kings 11,42-43)"
        },
        {
            id: 92,
            options: "Peter;John;Timothy",
            answer: "Paul",
            difficulty: "hard",
            type: "new",
            question: "Who shook a snake off into the fire?",
            description:
                '„When Paul had gathered a bundle of sticks and put them on the fire, a viper came out because of the heat and fastened on his hand. When the native people saw the creature hanging from his hand, they said to one another, "No doubt this man is a murderer. Though he has escaped from the sea, Justice has not allowed him to live." He, however, shook off the creature into the fire and suffered no harm.” (Acts. 28,3-5)'
        },
        {
            id: 93,
            options: "5 cubits;5 cubits and 2 spans;6 cubits",
            answer: "6 cubits and a span",
            difficulty: "hard",
            type: "old",
            question: "How tall was Goliath?",
            description:
                "„And there came out from the camp of the Philistines a champion named Goliath of Gath, whose height was six cubits and a span.” (1Samuel 17,4)"
        },
        {
            id: 94,
            options: "Samson;David;Saul",
            answer: "Absalom",
            difficulty: "hard",
            type: "old",
            question: "Whose hair got caught in an oak tree?",
            description:
                "„And Absalom happened to meet the servants of David. Absalom was riding on his mule, and the mule went under the thick branches of a great oak, and his head caught fast in the oak, and he was suspended between heaven and earth, while the mule that was under him went on.” (2Samuel 18,9)"
        },
        {
            id: 95,
            options: "Peter;John;Levi",
            answer: "Lazarus",
            difficulty: "easy",
            type: "new",
            question: "Who was Mary and Martha's brother?",
            description:
                "„Now a certain man was ill, Lazarus of Bethany, the village of Mary and her sister Martha. It was Mary who anointed the Lord with ointment and wiped his feet with her hair, whose brother Lazarus was ill.” (John 11,1-2)"
        },
        {
            id: 96,
            options: "Saul;Jonathan;Mephibosheth",
            answer: "David",
            difficulty: "hard",
            type: "old",
            question: "Who do we know for certain played the lyre?",
            description:
                "„And whenever the harmful spirit from God was upon Saul, David took the lyre and played it with his hand. So Saul was refreshed and was well, and the harmful spirit departed from him.” (1Samuel 16,23)"
        }
    ],
    "True-false": [
        {
            id: 341,
            question: "The unjust steward was dismissed from his job because of squandering his master's possessions.",
            answer: "True",
            description:
                "„There was a rich man who had a manager, and charges were brought to him that this man was wasting his possessions. And he called him and said to him, 'What is this that I hear about you? Turn in the account of your management, for you can no longer be manager.'” (Luke 16,1-2)"
        },
        {
            id: 492,
            question: "During Jacob's struggle with the angel, Jacob's hip was touched and wrenched out of place.",
            answer: "True",
            description:
                "„When the man saw that he did not prevail against Jacob, he touched his hip socket, and Jacob's hip was put out of joint as he wrestled with him.” (Genesis 32,25)"
        },
        {
            id: 492,
            question: "During Jacob's struggle with the angel, Jacob's hip was touched and wrenched out of place.",
            answer: "True",
            description:
                "„When the man saw that he did not prevail against Jacob, he touched his hip socket, and Jacob's hip was put out of joint as he wrestled with him.” (Genesis 32,25)"
        },
        {
            id: 1,
            question: "Jesus said: “Accept my grace!”",
            answer: "False",
            description: "Jesus never said that.",
            level: 18
        },
        {
            id: 2,
            question: "Jesus was born in Nazareth.",
            answer: "False",
            description:
                "„Now after Jesus was born in Bethlehem of Judea in the days of Herod the king, behold, wise men from the east came to Jerusalem,” (Matthew 2,1)",
            level: 11
        },
        {
            id: 3,
            question: "Noah had three sons: Ham, Shem and Japheth.",
            answer: "True",
            description: "„After Noah was 500 years old, Noah fathered Shem, Ham, and Japheth.” (Genesis 5,32)",
            level: 11
        },
        {
            id: 4,
            question: "Moses fled to Midian because he killed an Egyptian.",
            answer: "True",
            description:
                "„When Pharaoh heard of it, he sought to kill Moses. But Moses fled from Pharaoh and stayed in the land of Midian. And he sat down by a well.” (Exodus 2,15)",
            level: 47
        },
        {
            id: 5,
            question: "Jesus turned water into wine at the wedding in Jericho.",
            answer: "False",
            description:
                "„So he came again to Cana in Galilee, where he had made the water wine. And at Capernaum there was an official whose son was ill.” (John 4,46)",
            level: 22
        },
        {
            id: 6,
            question: "Jesus was first led away to High Priest Annas.",
            answer: "True",
            description:
                "„So the band of soldiers and their captain and the officers of the Jews arrested Jesus and bound him. First they led him to Annas, for he was the father-in-law of Caiaphas, who was high priest that year.” (John 18,12-13)",
            level: 48
        },
        {
            id: 7,
            question: "Martha was healed of her blindness by Jesus.",
            answer: "False",
            description: "She was not blind.",
            level: 28
        },
        {
            id: 8,
            question: "Abraham's first son was called Ishmael.",
            answer: "True",
            description: "His first son was Ishmael, the second son was Isaac.",
            level: 47
        },
        {
            id: 9,
            question: "Five loaves and two fish were used to feed the 5 000.",
            answer: "True",
            description:
                "„And taking the five loaves and the two fish he looked up to heaven and said a blessing and broke the loaves and gave them to the disciples to set before the people... And those who ate the loaves were five thousand men.” (Mark 6,41-44)",
            level: 9
        },
        {
            id: 10,
            question: "Moses led the children of Israel through the river Jordan into the Promised Land.",
            answer: "False",
            description: "Joshua led them over the river Jordan. Moses died on Mount Nebo.",
            level: 54
        },
        {
            id: 11,
            question: "Abel killed his brother Cain.",
            answer: "False",
            description:
                "„Cain spoke to Abel his brother. And when they were in the field, Cain rose up against his brother Abel and killed him.” (Genesis 4,8)",
            level: 29
        },
        {
            id: 12,
            question: "David was the first king of Israel.",
            answer: "False",
            description: "Saul was the first king. David was the second king of Israel.",
            level: 47
        },
        {
            id: 13,
            question: "Samuel was the last judge of Israel.",
            answer: "True",
            description:
                "During Samuel's life, the people of Israel asked for a king. With the first king, the era of Judges has come to an end.",
            level: 47
        },
        {
            id: 14,
            question: "Jesus was baptised by John the Baptist.",
            answer: "True",
            description:
                "„In those days Jesus came from Nazareth of Galilee and was baptized by John in the Jordan.” (Mark 1,9)",
            level: 18
        },
        {
            id: 15,
            question: "The Prodigal Son was hired to work as a tax collector.",
            answer: "False",
            description:
                "„So he went and hired himself out to one of the citizens of that country, who sent him into his fields to feed pigs.” (Luke 15,15)",
            level: 29
        },
        {
            id: 16,
            question: "Jesus saw Zacchaeus in a sycamore tree in Jericho.",
            answer: "True",
            description:
                "„So he ran on ahead and climbed up into a sycamore tree to see him, for he was about to pass that way.” (Luke 19,4)",
            level: 18
        },
        {
            id: 17,
            question: "Joshua sent three spies to Jericho who hid in Rahab's house.",
            answer: "False",
            description:
                '„And Joshua the son of Nun sent two men secretly from Shittim as spies, saying, "Go, view the land, especially Jericho." And they went and came into the house of a prostitute whose name was Rahab and lodged there.” (Joshua 2,1)',
            level: 59
        },
        {
            id: 18,
            question: "Daniel, Shadrach, and Abednego were thrown into a fiery furnace.",
            answer: "False",
            description:
                "„And he ordered some of the mighty men of his army to bind Shadrach, Meshach, and Abednego, and to cast them into the burning fiery furnace.” (Daniel 3,20)",
            level: 47
        },
        {
            id: 19,
            question: "The tenth plague unleashed on Egypt was the death of the firstborn.",
            answer: "True",
            description: "This plague was the last before the children of Israel left Egypt.",
            level: 22
        },
        {
            id: 20,
            question: "Balaam's horse was prevented from passing by an angel.",
            answer: "False",
            description:
                "„When the donkey saw the angel of the LORD, she lay down under Balaam. And Balaam's anger was kindled, and he struck the donkey with his staff.” (Numbers 22,27)",
            level: 60
        },
        {
            id: 21,
            question: "Stephen was stoned to death.",
            answer: "True",
            description:
                '„And as they were stoning Stephen, he called out, "Lord Jesus, receive my spirit." And falling to his knees he cried out with a loud voice, "Lord, do not hold this sin against them." And when he had said this, he fell asleep.” (Acts 7,59-60)',
            level: 47
        },
        {
            id: 22,
            question: "Jesus healed the man with the withered hand on the Sabbath.",
            answer: "True",
            description:
                '„And a man was there with a withered hand. And they asked him, "Is it lawful to heal on the Sabbath?"... Then he said to the man, "Stretch out your hand." And the man stretched it out, and it was restored, healthy like the other.” (Matthew 12,10-13)',
            level: 23
        },
        {
            id: 23,
            question: "Jonah spent three days and nights in the lions' den.",
            answer: "False",
            description:
                "„And the LORD appointed a great fish to swallow up Jonah. And Jonah was in the belly of the fish three days and three nights.” (Jonah 1,17)",
            level: 23
        },
        {
            id: 24,
            question: "Daniel was renamed Belteshazzar by Nebuchadnezzar.",
            answer: "True",
            description:
                "„At last Daniel came in before me--he who was named Belteshazzar after the name of my god, and in whom is the spirit of the holy gods--and I told him the dream, saying,” (Daniel 4,8)",
            level: 46
        },
        {
            id: 25,
            question: "Absalom was the son of Saul.",
            answer: "False",
            description:
                "„Now Absalom, David's son, had a beautiful sister, whose name was Tamar. And after a time Amnon, David's son, loved her.” (2Samuel 13,1)",
            level: 46
        },
        {
            id: 26,
            question: "Israel wandered in the wilderness for forty years.",
            answer: "True",
            description:
                "„And the LORD's anger was kindled against Israel, and he made them wander in the wilderness forty years, until all the generation that had done evil in the sight of the LORD was gone.” (Numbers 32,13)",
            level: 18
        },
        {
            id: 27,
            question: "The Apostle Paul was a fisherman.",
            answer: "False",
            description:
                "„After this Paul left Athens and went to Corinth... and because he was of the same trade he stayed with them and worked, for they were tentmakers by trade.” (Acts 18,1-3)",
            level: 13
        },
        {
            id: 28,
            question: "The Apostle Andrew was a tax collector.",
            answer: "False",
            description:
                "„While walking by the Sea of Galilee, he saw two brothers, Simon (who is called Peter) and Andrew his brother, casting a net into the sea, for they were fishermen.” (Matthew 4,18)",
            level: 21
        },
        {
            id: 29,
            question: "The Apostle Peter was a tentmaker.",
            answer: "False",
            description:
                "„While walking by the Sea of Galilee, he saw two brothers, Simon (who is called Peter) and Andrew his brother, casting a net into the sea, for they were fishermen.” (Matthew 4,18)",
            level: 18
        },
        {
            id: 30,
            question: "Zacchaeus was a chief tax collector.",
            answer: "True",
            description:
                "„And there was a man named Zacchaeus. He was a chief tax collector and was rich.” (Luke 19,2)",
            level: 23
        }
    ]
};
